module.exports = __webpack_public_path__ + "fonts/ionicons.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ../~/ionic-sdk/release/fonts/ionicons.ttf?v=2.0.1
 ** module id = 23
 ** module chunks = 0
 **/